import clsx from 'clsx'
import Image from 'next/image'

interface Props {
  title: string
  lists: {
    id: string | number
    title: string
    description: string
    image?: {
      url: string
      alternativeText: string
      width: number
      height: number
    }
  }[]
}

function PepperAdvantage({ title, lists }: Props) {
  return (
    <section className="font-body text-white bg-blue-web-90">
      <div className="container | py-16 md:py-20">
        <h3
          className="font-heading text-3xl md:text-5xl font-semibold | mb-14 md:mb-20"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {lists[0] ? (
            <div
              className={clsx(
                'flex flex-col lg:flex-row gap-7 lg:gap-28 md:col-span-12 text-blue-web-90 | border border-[#251F60] rounded-2xl overflow-hidden'
              )}
              style={{
                background:
                  'linear-gradient(180deg, #251F60 0%, rgba(37, 31, 96, 0.00) 100%)'
              }}
            >
              <div className="flex flex-col justify-center | py-5 px-6 md:px-10">
                <h3
                  className="font-heading text-2xl md:text-3xl font-semibold text-white | mb-3 md:mb-6"
                  dangerouslySetInnerHTML={{ __html: lists[0].title }}
                />
                <span
                  className="text-base md:text-lg text-gray-20"
                  dangerouslySetInnerHTML={{ __html: lists[0].description }}
                />
              </div>
              <Image
                src={lists[0].image?.url ?? ''}
                alt={lists[0].image?.alternativeText ?? ''}
                width={lists[0].image?.width}
                height={lists[0].image?.height}
                className="pl-6 lg:ml-auto lg:max-w-lg md:pt-10"
              />
            </div>
          ) : null}
          {lists[1] ? (
            <div
              className={clsx(
                'flex flex-col gap-10 md:col-span-6 text-blue-web-90 | border border-[#251F60] rounded-2xl overflow-hidden'
              )}
              style={{
                background:
                  'linear-gradient(180deg, #251F60 0%, rgba(37, 31, 96, 0.00) 100%)'
              }}
            >
              <div className="py-10 px-6 md:px-10 md:pt-10 flex-grow">
                <h3
                  className="font-heading text-2xl md:text-3xl font-semibold text-white | mb-3 md:mb-6"
                  dangerouslySetInnerHTML={{ __html: lists[1].title }}
                />
                <span
                  className="text-base md:text-lg text-gray-20"
                  dangerouslySetInnerHTML={{ __html: lists[1].description }}
                />
              </div>
              <Image
                src={lists[1].image?.url ?? ''}
                alt={lists[1].image?.alternativeText ?? ''}
                width={lists[1].image?.width}
                height={lists[1].image?.height}
                className="pl-10 lg:ml-auto"
              />
            </div>
          ) : null}
          {lists[2] ? (
            <div
              className="flex flex-col gap-10 md:col-start-7 md:col-end-13 text-blue-web-90 | border border-[#251F60] rounded-2xl overflow-hidden"
              style={{
                background:
                  'linear-gradient(180deg, #251F60 0%, rgba(37, 31, 96, 0.00) 100%)'
              }}
            >
              <div className="py-5 px-6 md:px-10 md:pt-10 flex-grow">
                <h3
                  className="font-heading text-2xl md:text-3xl font-semibold text-white | mb-3 md:mb-6"
                  dangerouslySetInnerHTML={{ __html: lists[2].title }}
                />
                <span
                  className="text-base md:text-lg text-gray-20"
                  dangerouslySetInnerHTML={{ __html: lists[2].description }}
                />
              </div>
              <Image
                src={lists[2].image?.url ?? ''}
                alt={lists[2].image?.alternativeText ?? ''}
                width={lists[2].image?.width}
                height={lists[2].image?.height}
                className="px-6 md:px-10 pb-5"
              />
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default PepperAdvantage
